import { Component, Input } from '@angular/core';

import { CompanyIntegrationsModel } from '../companies/models/company.integrations';
import { SessionModel }             from '../sessions/models/session';

@Component({
  selector   : 'wor-haynes-pro-settings',
  template: require('./haynes-pro.settings.component.html')
})
export class HaynesProSettingsComponent {
  @Input() session : SessionModel;
  @Input() settings: CompanyIntegrationsModel;
}
